import { render } from "./TopNavigationBar.vue?vue&type=template&id=5445404e"
import script from "./TopNavigationBar.vue?vue&type=script&lang=js"
export * from "./TopNavigationBar.vue?vue&type=script&lang=js"
script.render = render

export default script